import { environment } from '../../../environments/environment.local';

export const portUriTemplate = (portId?: string): string => {
  return `${environment.API.PORTS_URI}/${portId}`;
};
